import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductPresentation() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const recipes = ['Glaseado de limón perfecto', 'Cobertura de chocolate brillante', 'Glaseado de vainilla clásico', 'Coberturas de caramelo', 'Salsas dulces para budines', 'Toppings crocantes irresistibles'];
  const targetAudience = ['Te gusta preparar budines caseros', 'Querés mejorar tus recetas dulces', 'Querés que tus budines se vean más profesionales', 'Te gusta sorprender con postres caseros', 'O incluso si querés empezar a vender budines'];
  return <section className="py-20 bg-[#FFF5EB] text-[#3D2B1F] px-4" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <div className="text-center mb-16" data-id="element-139">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-140">
            Por eso creamos esta guía.
          </h2>
          <p className="text-xl md:text-2xl text-[#6B5344] leading-relaxed max-w-3xl mx-auto" data-id="element-141">
            Un recetario práctico con 30 coberturas y glaseados irresistibles
            que pueden transformar cualquier budín casero en un postre que
            parece salido de una pastelería.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl border border-[#3D2B1F]/10 shadow-lg" data-id="element-143">
            <h3 className="text-2xl font-bold text-[#C67B30] mb-6" data-id="element-144">
              Imaginá poder preparar:
            </h3>
            <ul className="space-y-4" data-id="element-145">
              {recipes.map((recipe, index) => <li key={index} className="flex items-start gap-3" data-id="element-146">
                  <CheckCircle2Icon className="w-6 h-6 text-[#C67B30] shrink-0 mt-0.5" data-id="element-147" />
                  <span className="text-lg text-[#4A3728]" data-id="element-148">{recipe}</span>
                </li>)}
            </ul>
            <p className="mt-8 text-[#9C8578] font-medium italic" data-id="element-149">
              Todo con recetas simples que elevan cualquier budín al siguiente
              nivel.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl border border-[#3D2B1F]/10 shadow-lg" data-id="element-150">
            <h3 className="text-2xl font-bold text-[#C67B30] mb-6" data-id="element-151">
              Este libro es perfecto para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-152">
              {targetAudience.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-153">
                  <CheckCircle2Icon className="w-6 h-6 text-[#C67B30] shrink-0 mt-0.5" data-id="element-154" />
                  <span className="text-lg text-[#4A3728]" data-id="element-155">{item}</span>
                </li>)}
            </ul>
            <p className="mt-8 text-[#9C8578] font-medium italic" data-id="element-156">
              Porque muchas veces el detalle que hace la diferencia está en el
              acabado final.
            </p>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-157">
          <p className="text-xl text-[#9C8578] mb-8 max-w-2xl mx-auto" data-id="element-158">
            Con recetas fáciles que cualquiera puede preparar en minutos. Sin
            ingredientes raros. Sin técnicas complicadas. Solo combinaciones que
            funcionan.
          </p>
          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-gradient-to-r from-[#C67B30] to-[#D4943A] text-white font-black text-xl md:text-2xl py-5 px-10 rounded-xl shadow-[0_0_20px_rgba(198,123,48,0.3)] hover:shadow-[0_0_30px_rgba(198,123,48,0.5)] transform hover:scale-105 transition-all duration-300 uppercase tracking-wide" data-id="element-159">
            🔥 ¡Quiero transformar mis budines hoy!
          </button>
        </div>
      </div>
    </section>;
}